<div class="container">
  <div class="content-grid">
    <div>
      <h1>Settings</h1>

      <div class="menu-desktop">
        <app-vertical-menu
          [labels]="menuLabels"
          [selectedIndex]="selectedMenuIndex"
          (clickMenu)="onClickMenu($event)"
        ></app-vertical-menu>
      </div>

      <div>
        <button mat-stroked-button class="menu-mobile" [matMenuTriggerFor]="menu">
          {{ currentSectionMenu.label }} <i class="material-icons">arrow_drop_down</i>
        </button>
        <mat-menu #menu="matMenu">
          @for (menu of menus; track menu; let i = $index) {
            <button mat-menu-item (click)="onClickMenu(i)">
              {{ menu.label }}
            </button>
          }
        </mat-menu>
      </div>
    </div>

    <div class="settings-content">
      <app-breadcrumb [breadcrumbList]="breadcrumbList"></app-breadcrumb>

      @if (currentSectionMenu.param == 'profile') {
        <app-edit-profile [userInfo]="userInfo"> </app-edit-profile>
      }

      @if (currentSectionMenu.param == 'password') {
        <app-change-password></app-change-password>
      }
    </div>
  </div>
</div>
